import styled from 'styled-components'
import { Select } from '@sainsburys-tech/bolt'

const SelectContainer = styled(Select)`
  margin-bottom: 10px;
`
export { SelectContainer }
